import React, { Component } from 'react'
import { NormalPeoplePicker } from '@fluentui/react';
import Api from '../../services/Api'

class PeoplePicker extends Component {

    defaultUsers = [];

    constructor(props) {
        super(props);

        // Set the initial state for the picker data source.
        // The people list is populated in the _onFilterChanged function.
        this._peopleList = null;
        this._searchResults = [];
    
        this._showError = this._showError.bind(this);
        this.state = {
          selectedPeople: null,
          isLoadingPeople: false,
          isLoadingPics: false,
          setByCode: false
        };
    }

    _mapUsersToPersonas(users) {
        const u = Array.isArray(users) ? users : [users];
        return u.reduce((result, p) => { 
            if(p) {
                const persona = {
                    text: p.displayName,
                    secondaryText: p.email,
                    props: { 
                        id: p.id 
                    },
                    apiObject: p
                };

                // persona.imageInitials = (!!p.givenName && !!p.surname) ? 
                //     p.givenName.substring(0,1) + p.surname.substring(0,1) : p.displayName.substring(0,1);
                //persona.initialsColor = Math.floor(Math.random() * 15) + 0;
                //persona.initialsColor = initialsColorPropToColorCode()
            
                result.push(persona);
            }
            return result;
        }, []);
    }

    // Handler for when text is entered into the picker control.
    // Populate the people list.
    _onFilterChanged_old(filterText, items) {
        if (this._peopleList) {

            return filterText ? this._peopleList.concat(this._searchResults)
                .filter(item => item.text.toLowerCase().indexOf(filterText.toLowerCase()) === 0)
                .filter(item => !this._listContainsPersona(item, items)) : [];
        } 
        else {            
            
            this.setState({
                isLoadingPeople: true,
                isLoadingPics: true
            });

            return new Promise( (resolve, reject) => this._getPeople((err, people) => {
                if (!err) {
                    this.setState({
                        isLoadingPeople: false
                    });

                    this._peopleList = this._mapUsersToPersonas(people, false);
                    this._getPics(this._peopleList);
                    resolve(this._peopleList);
                }
                else { this._showError(err); }
            })).then(value => value.concat(this._searchResults)
                .filter(item => item.text.toLowerCase().indexOf(filterText.toLowerCase()) === 0)
                .filter(item => !this._listContainsPersona(item, items)));
        }
    }

    // Remove currently selected people from the suggestions list.
    _listContainsPersona(persona, items) {
        if (!items || !items.length || items.length === 0) {
          return false;
        }
        return items.filter(item => item.text === persona.text).length > 0;
    }
    
    // Handler for when the Search button is clicked.
    // This sample returns the first 20 matches as suggestions.
    _onFilterChanged(searchText, items) {

        if(!searchText)
            return [];

        this.setState({
            isLoadingPeople: true,
            isLoadingPics: true
        });

        return new Promise((resolve, reject) => {
            this._searchUsers(searchText.toLowerCase(), (err, people) => {
                if (!err) {
                    this._searchResults = this._mapUsersToPersonas(people, true);

                    this.setState({
                        isLoadingPeople: false
                    });    

                    this._getPics(this._searchResults);
                    resolve(this._searchResults.filter(item => !this._listContainsPersona(item, items)));
                }
                else { this._showError(err); }
            });
        });
    }


    // Handler for when the selection changes in the picker control.
    // This sample updates the list of selected people and clears any messages.
    _onSelectionChanged(items) { 
        if(this.props.onSelectedUsers) {
            this.props.onSelectedUsers(items.map(u => u.apiObject));
        }
        
        this.setState({
            error: null,
            selectedPeople: items
        });
    }

    // Configure the error message.
    _showError(err) {
        this.setState({ error: `Error: ${err.message}` });
    }

    _searchUsers = (filter, callback) => {
        Api.get(`/User?search=${encodeURIComponent(filter)}&includeGroups=${!!this.props.includeGroups}`)
        // .then(res => {
        //     return res.json().then(json => {return res.ok ? json : Promise.reject(json)})
        // })
        .then(res => res.data)
        .then(users => {
            callback(null, users);
        })
        .catch(error => {
            callback(error);
        });
    }

    _getPeople = (callback) => {
        Api.get(`/User/People`)
        .then(res => res.data)
        .then(users => {
            callback(null, users);
        })
        .catch(error => {
            callback(error);
        });
    }

    _getPics() {
        this.setState({
            isLoadingPics: false
        });
    }

    _getSelectedPeople() {
        let selected = [];

        const selectedPeople = this.state.selectedPeople;
        if(selectedPeople !== null) {
            selected = selectedPeople;
        } else if(this.props.defaultUsers) {
            selected = this._mapUsersToPersonas(this.props.defaultUsers);
        }

        return selected;
    }


    render() { 
        
        const suggestionsProps = {
            //suggestionsHeaderText: 'Suggested People',
            noResultsFoundText: 'No results found',
            //searchForMoreText: 'Search',
            loadingText: 'Loading...' ,
            isLoading: this.state.isLoadingPics
        };

        const pickerStyles = {
            // root: {
            //     maxHeight: '60px',
            //     overflowY: 'auto',
            //     ...(!this.props.disabled && { border: '1px solid rgb(138, 136, 134)', borderRadius: '2px' })
            // },
            // text: {
            //     ...(!this.props.disabled && { border: 'none' })
            // }
            input: {
                display: this.props.disabled ? 'none' : 'block',
                height: '26px'
            },
            text: {
                padding: '4px 2px',
                minHeight: '36px'
            }
        }
        
        return (
            <div>
                <NormalPeoplePicker
                    onResolveSuggestions={ this._onFilterChanged.bind(this) }
                    pickerSuggestionsProps={ suggestionsProps }
                    getTextFromItem={ (persona) => persona.text }
                    onChange={ this._onSelectionChanged.bind(this) }
                    //onGetMoreResults={ this._onGetMoreResults.bind(this) }
                    selectedItems={ this._getSelectedPeople() }
                    itemLimit={ this.props.itemLimit }
                    resolveDelay={ 500 }
                    disabled={ this.props.disabled }
                    className='ms-PeoplePicker'
                    key='normal-people-picker'
                    styles={pickerStyles}
                />
                {
                    this.state.error &&
                    <div className='errorMessage'>
                        { this.state.error }
                    </div> 
                }
                {
                    this.props.errorMessage &&
                    <div className='errorMessage'>
                        { this.props.errorMessage }
                    </div> 
                }
            </div>
        )
    }
}

export const mapDbUserForPeoplePicker = (user) => {
    return {
        id: user.userId,
        displayName: user.displayName,
        email: user.email,
        jobTitle: '',
        givenName: '',
        surName: '',
        manager: null,
        role: user.role
    }
}

export default PeoplePicker



// WEBPACK FOOTER //
// ./src/components/formFields/PeoplePicker.js